import {SyncEventType} from '../../enums/syncEventType';
import {PersistenceEvent} from './persistenceEvent';

export class EventUserLoggedOutPers implements PersistenceEvent {

  public readonly type = SyncEventType.USERLOGGEDOUT;
  avatar: string;
  constructor(avatar: string) {
    this.avatar = avatar;
  }

  getPayload(): object {
    return {
      'avatar': this.avatar
    };
  }

  static fromPayload(payload: any): EventUserLoggedOutPers {
    return new EventUserLoggedOutPers(
      payload['avatar']
    );
  }

}

